import React, { useState, useEffect, useContext } from 'react'
import jwtDecode from 'jwt-decode'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import DangerousIcon from '@mui/icons-material/Dangerous'
import { AuthContext } from '../../../../contexts/Auth'
import { api } from '../../../../services/api'
import { saveHistoryAccess } from '../../../../services/saveHistoryAccess'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const SessionLogout = (props) => {
  const { logoutSystem } = useContext(AuthContext)
  const [open, setOpen] = useState(false)
  const [token, setToken] = useState(null)

  useEffect(() => {
    const _token = localStorage.getItem('token')
    const infoToken = jwtDecode(_token)

    window.onpopstate = () => {
      localStorage.setItem('refreshPage', true)
      saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
      logoutSystem('')
    }

    if (_token) {
      setToken(_token)
      api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
      logoutSystem('')
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setOpen(props.openModal)
  }, [props.openModal])

  const handleClose = () => {
    setOpen(false)
    localStorage.setItem('refreshPage', true)
    const infoToken = jwtDecode(token)
    saveHistoryAccess(infoToken.userId, 'Logout', 'logout', '', '')
    logoutSystem('')
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          // Set 'open' to false, however you would do that with your particular code.
          setOpen(false)
        }
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="icon-dialog">
          <DangerousIcon className="icon-error-dialog" />
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={'span'}>
          <div className="content-dialog">
            <span>Houve um login em outro dispositivo. Essa sessão será encerrada.</span>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className="btn-dialog">
          <button type="button" className="btn-blue" onClick={handleClose}>
            OK
          </button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default SessionLogout
